"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = (function (Dialogs$, onKickOccupant, get) {
    Dialogs$.on(onKickOccupant, function () {
        get();
    });
});
//# sourceMappingURL=onKickOccupant.js.map